import * as t from "io-ts";
import { DateTime } from "luxon";
export const isoDateTime = new t.Type("isoDateTime", (u) => DateTime.isDateTime(u) && u.isValid, (i, ctx) => {
    if (typeof i !== "string") {
        return t.failure(i, ctx, "Not a date string: " + i);
    }
    const dateTime = DateTime.fromISO(i, { setZone: true });
    if (!dateTime.isValid) {
        return t.failure(i, ctx, "Invalid date: " + dateTime.invalidExplanation);
    }
    return t.success(dateTime);
}, (v) => {
    if (v.isValid) {
        const result = v.toISO();
        if (result) {
            return result;
        }
    }
    throw new Error("Cannot serialize invalid date");
});
//# sourceMappingURL=date-time.js.map